import { getActiveClient } from 'store/active-client';

const env = process.env.NODE_ENV === 'development' ? process.env.NODE_ENV : process.env.REACT_APP_STAGE || 'production';

export const buildLocStoreKeys = () => {
  let suffix: string;

  try {
    const client = getActiveClient();
    const clientId = client?.id || sessionStorage.getItem('ehr_active_client_id');
    suffix = clientId ? `${clientId}_${env}` : env;
  } catch (err) {
    suffix = env;
  }

  return {
    ACCESS_TOKEN: `ehr_acctkn_${env}`,
    REFRESH_TOKEN: `ehr_rfrshtkn_${env}`,
    USER_ID: `ehr_usr_id_${env}`,
    USER_NAME: `ehr_usr_name_${env}`,
    USER_EMAIL: `ehr_usr_email_${env}`,
    IS_2FA_COMPLETE: `ehr_2fa_cmplt_${env}`,
    IS_2FA_ENABLED: `ehr_2fa_enbld_${env}`,
    WORK_MODE: `ehr_work_mode_${env}`,
    WORK_MODE_NAME: `ehr_work_mode_name_${env}`,
    ALT_WORK_MODE_NAME: `ehr_alt_work_mode_name_${env}`,
    PERMISSIONS: `ehr_permissions_${suffix}`,
    LANGUAGE: `ehr_lang_${suffix}`,
    PAID_LEAVE_DAYS: `ehr_paid_leave_days_${suffix}`,
    PAID_LEAVE_DAYS_BY_YEAR: `ehr_paid_leave_days_by_year_${suffix}`,
    PAID_LEAVE_DAYS_SERVED_TIME: `ehr_paid_leave_days_served_time_${suffix}`,
    PAID_LEAVE_DAYS_IRREGULAR_WORKING_HOURS: `ehr_paid_leave_days_irregular_working_hours_${suffix}`,
    PAID_LEAVE_DAYS_SPECIFIC_WORKING_CONDITIONS: `ehr_paid_leave_days_specific_working_conditions_${suffix}`,
    PAID_LEAVE_DAYS_ADDITIONAL_LEAVE: `ehr_paid_leave_days_additional_leave_${suffix}`,
    FEATURE_LEAVES: `ehr_feature_leaves_${suffix}`,
    FEATURE_LEAVE_REVIEW: `ehr_feature_leaves_review_${suffix}`,
    FEATURE_LEAVES_HALF_DAY: `ehr_feature_leaves_half_day_${suffix}`,
    FEATURE_FORM_76: `ehr_feature_form_76_${suffix}`,
    FEATURE_COLLEAGUES_LEAVES: `ehr_feature_colleagues_leaves_${suffix}`,
    FEATURE_EXIT_INTERVIEW: `ehr_feature_exit_interview_${suffix}`,
    FEATURE_SICK_LEAVE_WITHOUT_ATTACHMENT: `ehr_feature_sick_leave_without_attachment_${suffix}`,
    FEATURE_ART157_LEAVE_WITHOUT_ATTACHMENT: `ehr_feature_art157_leave_without_attachment_${suffix}`,
    FEATURE_LEAVE_DAYS_SERVED_TIME: `ehr_feature_leave_days_served_time_${suffix}`,
    FEATURE_LEAVE_DAYS_IRREGULAR_WORKING_HOURS: `ehr_feature_leave_days_irregular_working_hours_${suffix}`,
    FEATURE_LEAVE_DAYS_SPECIFIC_WORKING_CONDITIONS: `ehr_feature_leave_days_specific_working_conditions_${suffix}`,
    FEATURE_LEAVE_DAYS_ADDITIONAL_LEAVE: `ehr_feature_leave_days_additional_leave_${suffix}`,
    FEATURE_HOURLY_ABSENCES: `ehr_feature_hourly_absences_${suffix}`,
    FEATURE_HEALTH_AND_SAFETY_TRAINING: `ehr_feature_health_and_safety_training_${suffix}`,
    FEATURE_WORK_TRIPS: `ehr_feature_work_trips_${suffix}`,
    FEATURE_CUSTOM_FEATURE_FOR_CLIENT_F: `ehr_feature_custom_feature_for_client_f_${suffix}`,
    FEATURE_LIMIT_WFH_LEAVE_DAYS: `ehr_feature_limit_wfh_leave_days_${suffix}`,
    FEATURE_SHOW_WFH_LEAVE_TYPE_IN_MAIN_DROPDOWN: `ehr_feature_show_wfh_leave_type_in_main_dropdown_${suffix}`,
    FEATURE_GROUP_ROLE_LIMITS_IS_ACTIVE: `ehr_feature_group_role_limits_is_active_${suffix}`,
    FEATURE_REMINDER_FOR_PROBATION_PERIOD_END: `ehr_feature_reminder_for_probation_period_end_${suffix}`,
    FEATURE_LIMIT_DOCUMENTS_TO_LEAVES: `ehr_feature_limit_documents_to_leaves_${suffix}`,
    REMINDER_FOR_ID_CARD_EXPIRATION: `ehr_reminder_for_id_card_expiration_${suffix}`,
    FEATURE_LEAVE_SUBSTITUTE_EMPLOYEE: `ehr_feature_leave_substitute_employee_${suffix}`,
    FEATURE_REQUIRE_LEAVE_SUBSTITUTE_EMPLOYEE: `ehr_feature_require_leave_substitute_employee_${suffix}`,
    FEATURE_EMPLOYEE_CANDIDATES_IS_ACTIVE: `ehr_feature_employee_candidates_is_active_${suffix}`,
    SHOULD_DISALLOW_LEAVE_DAYS: `ehr_should_disallow_leave_days_${suffix}`,
    DISALLOWED_LEAVES_FROM: `ehr_disallowed_leaves_from_${suffix}`,
    DISALLOWED_LEAVES_TO: `ehr_disallowed_leaves_to_${suffix}`,
    WFH_LIMIT_TYPE: `ehr_wfh_limit_type_${suffix}`,
    REMAINING_WFH_LEAVES_PER_WEEK: `ehr_remaining_wfh_leaves_per_week_${suffix}`,
    REMAINING_WFH_LEAVES_PER_MONTH: `ehr_remaining_wfh_leaves_per_month_${suffix}`,
    IS_CANDIDATE: `ehr_is_candidate_${suffix}`,
    EMPLOYEE_CANDIDATE_HELP_TEXT: `ehr_employee_candidate_help_text_${suffix}`,
    TOTAL_HOURLY_ABSENCES_REMAINING_HOURS: `ehr_total_hourly_absences_remaining_hours_${suffix}`,
    TOTAL_HOURLY_ABSENCES_UNCOVERED_HOURS: `ehr_total_hourly_absences_uncovered_hours_${suffix}`,
    TOTAL_HOURLY_ABSENCES_HOURS_ABOUT_TO_BE_COVERED: `ehr_total_hourly_absences_hours_about_to_be_covered_${suffix}`,
    HAS_AVAILABLE_ARCHIVES: `ehr_has_available_archives_${suffix}`,
    AVAILABLE_UNDOWNLOADED_ARCHIVES_COUNT: `ehr_available_undownloaded_archives_count_${suffix}`,
    IN_PROGRESS_ARCHIVES_COUNT: `ehr_in_progress_archives_count_${suffix}`,
    LAST_ARCHIVE_EXPIRES_AT: `ehr_last_archive_expires_at_${suffix}`,
  };
};

export const PermissionKeys = {
  CAN_SWITCH_WORK_MODE: 'can_switch_work_mode',
  CAN_SEE_EMPLOYER_NAV: 'can_see_employer_nav',
  CAN_SEE_EMPLOYEE_NAV: 'can_see_employee_nav',
  CAN_SELECT_DOC_WIZARD_EMPLOYEE: 'can_select_doc_wizard_employee',
  CAN_SELECT_DOC_WIZARD_STEP5_ACTIONS: 'can_select_doc_wizard_step5_actions',
  CAN_CREATE_MASS_DOCUMENTS: 'can_create_mass_documents',
  CAN_APPROVE_DOCUMENTS: 'can_approve_documents',
  CAN_CREATE_DOCUMENTS: 'can_create_documents',
  CAN_SIGN_DOCUMENTS: 'can_sign_documents',
  CAN_MANAGE_EMPLOYEES: 'can_manage_employees',
  CAN_MANAGE_MODERATORS: 'can_manage_moderators',
  CAN_MANAGE_EMPLOYERS: 'can_manage_employers',
  CAN_MANAGE_GROUPS: 'can_manage_groups',
  CAN_MANAGE_ROLES: 'can_manage_roles',
  CAN_MANAGE_DOCUMENT_PERMISSIONS: 'can_manage_document_permissions',
  CAN_IMPORT_EMPLOYEES: 'can_import_employees',
  CAN_MULTI_SIGN: 'can_multi_sign',
  CAN_MULTI_DELETE: 'can_multi_delete',
  CAN_MULTI_APPROVE: 'can_multi_approve',
  CAN_MULTI_SEND: 'can_multi_send',
  CAN_ACCESS_MUNICIPALITY_REPORT: 'can_access_municipality_report',
  CAN_MANAGE_MANUALLY_ADDED_LEAVES: 'can_manage_manually_added_leaves',
  CAN_MANAGE_LEAVES: 'can_manage_leaves',
  CAN_MANAGE_HOURLY_ABSENCES: 'can_manage_hourly_absences',
  CAN_MANAGE_HEALTH_AND_SAFETY_TRAINING: 'can_manage_health_and_safety_training',
  CAN_MANAGE_WORK_TRIPS: 'can_manage_work_trips',
  CAN_DOWNLOAD_USER_DATA_REPORT: 'can_download_user_data_report',
  CAN_VIEW_SENSITIVE_FIELDS_ON_USER_DATA_REPORT: 'can_view_sensitive_fields_on_user_data_report',
};
